const rethrow = err => Promise.reject(err);
const isOnline = () => window.navigator && window.navigator.onLine;
const type = status => (status / 100) | 0;

const getTokenFromStorage = () => {
  if (window && window.localStorage) {
    let token;
    try {
      token = JSON.parse(window.localStorage.getItem("auth_token"));
    } catch (e) {
      return;
    }
    return token;
  }
};

const decorate = res =>
  Object.assign(res, {
    info: type(res.status) === 1,
    ok: type(res.status) === 2,
    client: type(res.status) === 4,
    srv: type(res.status) === 5,
    err: type(res.status) === 5 || type(res.status) === 4 || res.status === 0,
  });

const withResponse = res => {
  return decorate(
    Object.assign(res.data, {
      status: res.status,
      headers: res.headers,
    })
  );
};

const withRequest = res => {
  return decorate({
    status: res.status,
    online: isOnline(),
  });
};

const successResponse = res => {
  console.log(res);
  return res.data.data ? res.data.data : {};
};

const failureResponse = res => {
  console.log(res);
  return res.response
    ? rethrow(withResponse(res.response))
    : res.request
      ? rethrow(withRequest(res.request))
      : rethrow(res);
};

module.exports = {
  successResponse,
  failureResponse,
  rethrow,
  getTokenFromStorage,
};



// WEBPACK FOOTER //
// ../shared/optilit-http-client/src/utils.js